import { render, staticRenderFns } from "./DeleteDraftConfirm.vue?vue&type=template&id=606be7a4&"
import script from "./DeleteDraftConfirm.vue?vue&type=script&lang=ts&"
export * from "./DeleteDraftConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports